import helpers from "../common/helpers";

(function ($) {
  "use strict";

  const cntsHome = {
    init: function () {
      this.setup();
      this.start();
    },
    setup() {
      this.options = {
        $owlCarouselTestimonials: $("#owl-testimonials"),
      };
    },
    start() {
      cntsHome.carouselTestimonials();
    },

    carouselTestimonials() {
      const { $owlCarouselTestimonials } = this.options;

      $owlCarouselTestimonials.owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: true,
        items: 1,
      });
    },
  };

  $(document).ready(function () {
    cntsHome.init();
  });

  $(window).resize(function () {
    // cntsHome.carouselPostCards();
  });
})(jQuery);
